import { useCallback, useEffect } from 'react';

import { useLazyQuery } from '@apollo/client';

import { convertToUUID } from 'uuid-encoding';

import { ListProductCategoriesResponse, ProductType } from '../types';
import { GroupType } from 'graphql-query-contracts';

import gql from 'graphql-tag';
import { Channel } from '../../../types/ChannelType';

const ALL_PRODUCTS = ProductType.PRODUCT_TYPE_UNKNOWN;

const categoryListQuery = gql`
  query listProductCategories(
    $listProductCategoriesRequest: ListProductCategoriesRequest!
  ) {
    listProductCategories(
      listProductCategoriesRequest: $listProductCategoriesRequest
    ) {
      productCategory {
        productCategoryId
        name
        description
        productType
        groupId
        groupType
      }
      pageInfo {
        perPage
        start
        total
      }
    }
  }
`;

interface ListCategoryParams {
  page: number;
  pageSize: number;
  channel: Channel | undefined;
  productType?: ProductType;
}

export function useCategoryListQuery({
  page,
  pageSize,
  channel,
  productType = ALL_PRODUCTS,
}: ListCategoryParams) {
  const [getCategoryList, categoryListResponse] = useLazyQuery<{
    listProductCategories: ListProductCategoriesResponse;
  }>(categoryListQuery);

  const refetch = useCallback(async () => {
    if (channel) {
      const parentId = channel.parent?._id;
      const parentChannelIdArray =
        (parentId && [convertToUUID(parentId)]) || [];
      const groupIds = [convertToUUID(channel._id), ...parentChannelIdArray];

      getCategoryList({
        variables: {
          listProductCategoriesRequest: {
            filter: {
              groupIds,
              groupType: GroupType.GroupTypeActivateChannel,
              productType,
            },
            pagination: {
              start: page * pageSize,
              perPage: pageSize,
            },
          },
        },
      });
    }
  }, [channel, page, pageSize, getCategoryList, productType]);

  useEffect(() => {
    refetch();
  }, [channel, page, pageSize, getCategoryList, productType]);

  return { data: categoryListResponse.data, refetch };
}
